import { canShowSketchPropertySection, handleSketchEntityPropertyConfirm, registerPropertyManagerSection } from '@/core';
import { SketchCircleCommand } from '@puppycad/cad-core';
import CirclePropertySection from '@/components/editor/property-manager/circle/CirclePropertySection.vue';

registerPropertyManagerSection({
  id: SketchCircleCommand.CenterRadius,
  title: '圆',
  order: 12,
  component: CirclePropertySection,
  actions: {
    confirm: true,
  },
  onConfirm: handleSketchEntityPropertyConfirm,
  isApplicable: (context) => canShowSketchPropertySection(context, context.circlePropertyVisible === true),
});
